import { render, staticRenderFns } from "./RegistrationBrand.vue?vue&type=template&id=c04e38da&scoped=true"
import script from "./RegistrationBrand.vue?vue&type=script&lang=js"
export * from "./RegistrationBrand.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBrand.vue?vue&type=style&index=0&id=c04e38da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04e38da",
  null
  
)

export default component.exports